import { countries } from "../../constants";
import { useMobileContentResource } from "../../core/resource/MobileResourceProvider";
import {
  BMDropdownField,
  BMDropdownFieldProps,
  BMDropdownOptionsValue,
} from "../BMDropdownField";

const COUNTRY_CODE_LIST: BMDropdownOptionsValue<string>[] = countries.map(
  (info) => {
    const prefix = `+${info.telPref}`;
    return {
      label: `(${prefix}) ${info.countryName} (${info.countryId})`,
      value: prefix,
    };
  }
);

export type BMCountryCodePickerProps = Omit<
  BMDropdownFieldProps<string>,
  "option" | "variant" | "searchable" | "optionsSection"
>;

export default function BMCountryCodePicker(props: BMCountryCodePickerProps) {
  const { CorporateCountryCodePicker: cr } = useMobileContentResource();
  return (
    <BMDropdownField
      {...props}
      variant="RADIO"
      option={{
        items: COUNTRY_CODE_LIST,
      }}
      searchable={{
        placeholder: cr.placeholder,
      }}
      optionsSection={{
        title: cr.title,
        wrapperStyles: {
          minWidth: 250,
        },
      }}
    />
  );
}
